import type { RecordingData } from 'capacitor-voice-recorder';

export const useRecordingStore = defineStore('recording', {
  state: () => ({
    recordings: [] as Array<RecordingData['value']>
  }),
  getters: {
    getRecordingByPath: (state) => (path: RecordingData['value']['path']) =>
      state.recordings.find((r) => r.path === path)
  },
  actions: {
    addRecording(recording: RecordingData['value']) {
      this.recordings.push(recording);
    },
    removeRecordingByPath(path: RecordingData['value']['path']) {
      this.recordings = this.recordings.filter((r) => r.path !== path);
    }
  },
  persist: {
    storage: persistedState.localStorage
  }
});
